<div class="not-found-page flex-column-centered w-100 f-family-sfpro">
  <p class="not-found-page__code fz-12 lh-16 fw-500">{{ 'Shared.Not_found_page.Code' | translate }}</p>
  <p class="not-found-page__title fz-32 lh-32 fw-600 mt-16 mb-16">{{ 'Shared.Not_found_page.Title' | translate }}</p>
  <p class="not-found-page__desc fz-16 lh-24 fw-400">{{ 'Shared.Not_found_page.Description' | translate }}</p>
  <div class="mt-32">
    <button class="newest-button newest-button-sm" [routerLink]="buttonLink">{{ buttonLabel | translate }}</button>
  </div>
</div>